'use client';
import client from '@/lib/apollo';
import { ApolloProvider } from '@apollo/client';
import { DesignSystemProvider } from '@repo/design-system';
import dynamic from 'next/dynamic';
import React, { type ReactNode } from 'react';

const AuthProvider = dynamic(() => import('@repo/auth/provider'), {
  ssr: false,
});

export function RootProvider({ children }: { children: ReactNode }) {
  return (
    <AuthProvider>
      <ApolloProvider client={client}>
        <DesignSystemProvider>{children}</DesignSystemProvider>
      </ApolloProvider>
    </AuthProvider>
  );
} 